import { motion } from "framer-motion";

export const IntroScreen = ({ onStart }) => {
  return (
    <motion.div
      key="intro"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -24 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-1 flex-col items-center justify-center text-center"
      data-testid="intro-screen"
    >
      <span className="mb-5 inline-flex items-center rounded-full bg-coral/15 px-4 py-1.5 text-xs font-medium tracking-wide text-coral">
        Test del gonfiore
      </span>
      <h2 className="font-serif text-4xl font-bold leading-tight text-ink sm:text-5xl">
        Che tipo di
        <br />
        gonfiore hai?
      </h2>
      <p className="mt-5 max-w-xs text-base font-light leading-relaxed text-ink/70">
        Rispondi a poche domande e scopri il tuo profilo.
      </p>

      <button
        type="button"
        onClick={onStart}
        data-testid="start-test-button"
        className="mt-10 w-full max-w-xs rounded-2xl bg-coral px-8 py-4 text-lg font-semibold text-white shadow-lg shadow-coral/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-coral/40 active:translate-y-0"
      >
        Inizia il test
      </button>

      <p className="mt-6 max-w-xs text-xs leading-relaxed text-ink/45">
        Questo test non è una diagnosi e non sostituisce il parere di un medico.
      </p>
    </motion.div>
  );
};
